import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  class: "p-mx-2"
}
const _hoisted_3 = {
  key: 0,
  class: "p-float-label"
}
const _hoisted_4 = { class: "kn-material-input-label" }
const _hoisted_5 = {
  key: 1,
  class: "p-float-label"
}
const _hoisted_6 = { class: "kn-material-input-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_KnValidationMessages = _resolveComponent("KnValidationMessages")

  return (_ctx.filter.static && _ctx.filter.visible)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode(_component_InputText, {
          class: "kn-material-input p-mx-2",
          modelValue: _ctx.filter.filterValue,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.filter.filterValue = $event)),
          disabled: ""
        }, null, 8, ["modelValue"])
      ]))
    : (!_ctx.filter.static)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          (_ctx.filter.presentation === 'MANUAL')
            ? (_openBlock(), _createBlock("span", _hoisted_3, [
                _createVNode(_component_InputText, {
                  class: ["kn-material-input", {
                    'p-invalid': _ctx.v$.filter.filterValue.$invalid
                }],
                  modelValue: _ctx.v$.filter.filterValue.$model,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.v$.filter.filterValue.$model = $event)),
                  onInput: _ctx.filterChanged
                }, null, 8, ["modelValue", "onInput", "class"]),
                _createVNode("label", _hoisted_4, _toDisplayString(_ctx.filter.title), 1)
              ]))
            : (_ctx.filter.presentation === 'COMBO')
              ? (_openBlock(), _createBlock("span", _hoisted_5, [
                  _createVNode(_component_Dropdown, {
                    class: "kn-material-input",
                    modelValue: _ctx.v$.filter.filterValue.$model,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.v$.filter.filterValue.$model = $event)),
                    options: _ctx.options,
                    optionValue: "column_1",
                    optionLabel: "column_1",
                    onChange: _ctx.filterChanged,
                    filter: true
                  }, null, 8, ["modelValue", "options", "onChange"]),
                  _createVNode("label", _hoisted_6, _toDisplayString(_ctx.filter.title), 1)
                ]))
              : _createCommentVNode("", true),
          _createVNode(_component_KnValidationMessages, {
            vComp: _ctx.v$.filter.filterValue
          }, null, 8, ["vComp"])
        ]))
      : _createCommentVNode("", true)
}